const breakpoints = ["540px", "720px", "960px", "1140px"];

export default breakpoints;
